import i18next from 'i18next';

i18next.addResources('en', 'financing', {
  TITLE: 'Financing'
});
